import React from 'react'
import {Container, Row, Col } from 'react-bootstrap'

const InfoSection = () => {
  return (
    <Container className='info-section'>
        <Row>
            <Col lg="6" className='fs-7 px-3 font-weight-bold'>
                <p>
                    <span>
                    I am a photographer specializing in fashion and portrait photography.
                    The world of photography has been a major interest for me ever since I was a child. 
Iconic actor and musician portraits, fashion magazines and album cover photographs have always been a huge influence for me. 
I think that the most important skill required in the art of photographing people is rooted in the interpersonal skills 
and the ability to connect with another human being.    

                    </span>
                </p>
            </Col>
            <Col lg="6" className='fs-7 px-3'>
                <p>
                    <span>
                    I have photographed professionally since 2008 
and worked for various artists, productions, brands and fashion designers. I do also family portraits and CV portraits. 
I work mainly on my own studio, and locations around Helsinki area. What I don't do currenty is event photograpy.                        
                        My studio resides in Kuusisaari, Helsinki. 
                        My wife Deivi Paasimaa is my trusted make-up artist and also manages my bookings. 
                        You can book a photoshoot directly though www.deivi.fi or by sending me a whatsapp message
                        or calling me +358 40 841 0506. I don't read emails regularily nowadays...                         
                    </span>
                </p>
            </Col>

        </Row>

    </Container>
  )
}

export default InfoSection